export default [{
     name: '首页',
    path: '/',
    icon: require('../assets/menu/shouye.png'),
    classname:'shouye',
    authority: 'Manage Edit gov gov0 gov1 gov6 unaudited'
},
{
    name: '内容管理',
    icon: require('../assets/menu/guanli.png'),
    classname:'guanli',
    authority: 'Manage Edit gov gov0 gov1 gov6 unaudited',
    children: [
        {
            name: '内容发布',
            path: '/publish',
            authority: 'Manage Edit gov gov0 gov1 gov6'
        },
        {
            name: '内容管理',
            path: '/manage/content',
            authority: 'Manage Edit gov gov0 gov1 gov6 unaudited'
        },
        // {
        //     name: '材料收集',
        //     path: '/manage/stuff',
        //     match:['StuffContent'],
        //     authority: 'Manage zwhgxh gov gov0 gov1 gov6'
        // },
        {
            name: '视频素材管理',
            path: '/manage/material',
            match: ['SourceMaterialEnter'],
            authority: 'Manage Edit gov gov0 gov1 gov6 unaudited'
        },
        {
            name: '专辑管理',
            path: '/manage/authormedia',
            authority: 'Manage Edit gov gov0 gov1 gov6 unaudited'
        },
        {
            name: '内容发布列表',
            path: '/datastatistics/publishlist',
            authority: 'gov gov0 gov1 gov6'
        },
        {
            name: '内容发布统计',
            path: '/datastatistics/publishstatistics',
            authority: 'gov gov0 gov1 gov6'
        }
    ]
},
{
    name: '配置管理',
    icon: require('../assets/menu/guanli.png'),
    classname:'guanli',
    authority: 'Manage Edit gov gov0 gov1 gov6 unaudited',
    children: [
        {
            name: '评论管理',
            path: '/manage/comment',
            authority: 'Manage Edit gov gov0 gov1 gov6 unaudited'
        },
        {
            name: '水印管理',
            path: '/manage/watermark',
            authority: 'Manage gov gov0 gov1 gov6 unaudited'
        },
        {
            name: '荣誉榜排序配置',
            path: '/manage/honor/studio2/order',
            authority: 'Manage gov gov0 gov1 gov6 unaudited'
        },
    ]
},
{
    name: '数据统计',
    icon: require('../assets/menu/tongji.png'),
    classname:'tongji',
    authority: 'Manage Edit gov gov0 gov1 gov6 unaudited',
    children: [{
            name: '校园号数据统计',
            path: '/datastatistics/content',
            authority: 'Manage Edit gov gov0 gov1 gov6',
            match: 'datasummary,contentdata,exponential unaudited'
        },{
          name: '本校入驻校园号数据统计',
          path: '/datastatistics/school',
          authority: 'Manage Edit gov gov0 gov1 gov6 addschoolFlag'
      },
        // {
        //     name: '粉丝分析',
        //     path: '/datastatistics/fans',
        //     authority: 'Manage Edit gov gov0 gov1 gov6',
        //     match: 'fansummary,attribute,search,fanslist'
        // },
        // {
        //     name: '校园号排行列表',
        //     path: '/datastatistics/sort',
        //     authority: 'Manage Edit gov gov0 gov1 gov6 unaudited'
        // },
        {
            name: '高校号统计列表',
            path: '/datastatistics/schoollist',
            authority: 'gov gov6'
        },
        {
            name: '专栏号统计列表',
            path: '/datastatistics/personallist',
            authority: 'gov gov1'
        },
    ]
},
{
    name: '设置',
    icon: require('../assets/menu/shezhi.png'),
    classname:'shezhi',
    authority: 'Manage Edit gov gov0 gov1 gov6 forbid unaudited',
    children: [{
            name: '账号信息',
            path: '/settings/account',
            authority: 'Manage Edit gov gov0 gov1 gov6 forbid unaudited'
        },
        {
            name: '基本信息',
            path: '/settings/basic',
            // authority: 'Manage Edit gov gov0 gov1 gov6 forbid unaudited'
            authority: 'Manage gov gov0 gov1 gov6 Edit forbid unaudited studioAdmin'
        },
        {
            name: '账号管理',
            path: '/settings/studioaccount',
            authority: 'Manage gov gov0 gov1 gov6 Edit forbid unaudited studioAdmin'
        }
    ]
}]



// WEBPACK FOOTER //
// ./src/config/studio.js